module.exports = ["剛剛","%s 秒前","%s 分鐘前","%s 小時前","%s 天前","%s 週前","%s 月前","%s 年前"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/zh-TW.json
// module id = DTCq
// module chunks = 1